import React from "react"
import "../../styles/Benefits/Background.less"

const Background = (props) => {  return (
    <>
      <div className="GuaranteedIncome_Background">{props.children}</div>
    </>
  )
}

export default Background
